$(document).ready(() => {

    $(document).on('click','a[href="#"]',e => { e.preventDefault() })


    //===========input-inter==========//

    $('.content-error__total__content-token__code input').on('click', function (e) {
        $(this).focus().select();
    })
    $('.content-error__total__content-token__code input').on('keyup', function (e) {

        if (e.keyCode == 8 || e.keyCode == 46) {
            $(this).val('').prev('input').focus().select();
        }

        else {
            if ($(this).val().length == 1) {
                var $next = $(this).next('input');
                if ($next.length)
                    $(this).next('input').focus();
                else
                    $(this).blur();
            }
        }
    });

    //===========end input-inter==========//


    //=====menu mobile=========//
    $('[data-toggle]').on('click', function () {
        let toggle_name = $(this).data('toggle');
        let target_name = $(this).data('target');
        let target_element = $(
            '[data-toggle="showbox"][data-target="' + target_name + '"]'
        );
        if (toggle_name == 'openbox') {
            let target_status = target_element.data('status');
            $(
                '[data-toggle="showbox"]:not([data-target="' + target_name + '"])'
            ).attr('data-status', false);
            if (target_status == false) {
                target_element.attr('data-status', true);
            } else {
                target_element.attr('data-status', false);
            }
        } else if (toggle_name == 'closebox') {
            target_element.attr('data-status', false);
        }
    });
    $(document).on('click', function () {
        $('[data-toggle="showbox"]').attr('data-status', false);
    });
    $(document).on('keyup', function (e) {
        if (e.key === 'Escape') {
            $('[data-toggle="showbox"]').attr('data-status', false);
        }
    });
    $('[data-toggle="showbox"],[data-toggle="openbox"]').click(function (
        event
    ) {
        event.stopPropagation();
    });
    //=====end menu mobile======//


    //=============search=================//

    $(document).on("keyup", ".sidebar-archive-p__wrapper__title__search input", function () {
        var val = $(this).val();
        $(this).closest('.sidebar-archive-p__wrapper__title')
            .siblings('.sidebar-archive-p__wrapper__cat')
            .find("label").each(function (i, e) {
                if ($(e).html().toLowerCase().search(val.toLowerCase()) > -1) {
                    $(e).removeClass('no-result');
                }
                else {
                    $(e).addClass('no-result');
                }
            });
    })

    $(document).on("change", ".sidebar-archive-p__wrapper__cat input", e => {
        let _this = e.currentTarget
        if($(_this).parent().find('>ul').length){
            $(_this).parent().find('input').each((i,child)=>{
                $(child).prop('checked',e.currentTarget.checked)
            })
        }
        if($(_this).parent().siblings('li').find('>input').length + 1 === ($(_this).parent().siblings('li').find('>input:checked').length + e.currentTarget.checked)){
            $(_this).closest('ul').siblings('input').prop('checked',true)
        } else {
            $(_this).closest('ul').siblings('input').prop('checked',false)
        }
    })

    //=============end search=================//


    //=========Swiper=========//
    var S_banner_index = new Swiper('.s-header-index__wrapper__slider .swiper', {
        spaceBetween: 20,
        slidesPerView: 1,
        loop: true,
        navigation: {
            nextEl: '.prev',
            prevEl: '.next',
        },
        // autoplay: {
        //     delay: 3000,
        //     disableOnInteraction: 0,
        // },

        breakpoints: {
            576: {
                spaceBetween: 40,
            },
        },

    });

    var S_bestseller_index = new Swiper('.s-bestseller-index__wrapper__slider .swiper', {
        spaceBetween: 30,
        slidesPerView: 1.5,
        loop: true,
        // autoplay: {
        //     delay: 3000,
        //     disableOnInteraction: 0,
        // },

        breakpoints: {
            1200: {
                slidesPerView: 4,
            },
            768: {
                slidesPerView: 3,
            },
            576: {
                slidesPerView: 2,
            },
        },
    });

    var S_cup_cake_index = new Swiper('.s-cup-cake-index__wrapper__slider .swiper', {
        spaceBetween: 20,
        slidesPerView: 2,
        loop: true,
        // autoplay: {
        //     delay: 3000,
        //     disableOnInteraction: 0,
        // },

        breakpoints: {
            1200: {
                slidesPerView: 6,
            },
            576: {
                slidesPerView: 4,
            },
            480: {
                slidesPerView: 3,
            },
        },
    });

    var S_rebate_index = new Swiper('.s-rebate-index__total__context__wrapper__slider .swiper', {
        spaceBetween: 30,
        slidesPerView: 1.5,
        loop: true,
        // autoplay: {
        //     delay: 3000,
        //     disableOnInteraction: 0,
        // },

        breakpoints: {
            1200: {
                slidesPerView: 4,
            },
            768: {
                slidesPerView: 3,
            },
            576: {
                slidesPerView: 2,
            },
        },
    });

    var S_gallery_index = new Swiper('.s-gallery-index__row__col-larg__wrapper__slider .swiper', {
        spaceBetween: 30,
        slidesPerView: 1,
        loop: true,
        // autoplay: {
        //     delay: 3000,
        //     disableOnInteraction: 0,
        // },

        breakpoints: {
            1200: {
                slidesPerView: 4.5,
            },
            992: {
                slidesPerView: 4.2,
            },
            768: {
                slidesPerView: 3.1,
            },
            576: {
                slidesPerView: 2.1,
            },
            480: {
                slidesPerView: 1.5,
            },
        },

    });

    var S_article_index = new Swiper('.s-article-index__wrapper__slider .swiper', {
        spaceBetween: 30,
        slidesPerView: 1.5,
        loop: true,
        // autoplay: {
        //     delay: 3000,
        //     disableOnInteraction: 0,
        // },

        breakpoints: {
            1200: {
                slidesPerView: 4,
            },
            992: {
                slidesPerView: 4,
            },
            768: {
                slidesPerView: 3,
            },
            576: {
                slidesPerView: 2.3,
            },
            480: {
                slidesPerView: 1.7,
            },
        },

    });

    var S_article_index = new Swiper('.empty-cart__sidebare__slider .swiper', {
        spaceBetween: 30,
        slidesPerView: 1,
        loop: true,
        // autoplay: {
        //     delay: 3000,
        //     disableOnInteraction: 0,
        // },
    });

    var list_slider = new Swiper('.single-product__wrapper__gallery__slider__list-slider .swiper', {
        direction: 'horizontal',
        slidesPerView: 3,
        spaceBetween: 10,
        slideToClickedSlide: true,
        clickable: true,
        breakpoints: {
            992: {
                direction: 'horizontal',
                slidesPerView: 4,
                spaceBetween: 30,
            },
            480: {
                slidesPerView: 4,
            },
        },
    });

    var Sidebar_archive = new Swiper('.sidebar-archive-p__wrapper__slider .swiper', {
        spaceBetween: 30,
        slidesPerView: 1,
        loop: true,
        // autoplay: {
        //     delay: 3000,
        //     disableOnInteraction: 0,
        // },
        navigation: {
            nextEl: '.sidebar-archive-p .prev',
            prevEl: '.sidebar-archive-p .next',
        },
    });

    //=========End Swiper=========//


    //=======countdowun=======//


    $('.single-product__wrapper__gallery__slider__list-slider__item').on('click', function () {
        $('.single-product__wrapper__gallery__slider__list-slider__item.active').removeClass('active');
        $(this).addClass('active')
    });

    $(document).on("click", ".single-product__wrapper__gallery__slider__list-slider__item img", function () {
        let img_src = $(this).data("src");
        $(this).closest(".single-product__wrapper__gallery__slider").find(".single-product__wrapper__gallery__slider__image img").attr("src", img_src);
        let data_zoom_image = $(this).data("zoom-image");
        xoriginal = $(this).closest(".single-product__wrapper__gallery__slider").find(".single-product__wrapper__gallery__slider__image img").attr("xoriginal", data_zoom_image);
    })


    //=======countdowun=======//

    $(".s-rebate-index__total__context__wrapper__slider__item__content__top__arrived").each(function (i, e) {

        var start_time = new Date($(e).data('start')),
            finish_time = new Date($(e).data('finish'))

        $(e).find(".timer").countdown(finish_time, function (event) {

            var current_time = new Date(),
                per_time = 100 / (Math.abs(finish_time - start_time) / 1000),
                pass_time = (Math.abs(current_time - start_time) / 1000) * per_time;

            if (finish_time > current_time && current_time > start_time) {
                var format = '%H : %M';
                if (event.offset.hours > 0) {
                    format = '%S : ' + format;
                }
                if (event.offset.days > 0) {
                    format = '%-D روز' + format;
                }

                $(e).find(".s-rebate-index__total__context__wrapper__slider__item__content__top__arrived__title span").html(event.strftime(format));
                $(e).find(".s-rebate-index__total__context__wrapper__slider__item__content__top__arrived__progressbar__development").css("width", pass_time + '%');

            }

        })
    });


    $(".single-product__wrapper__content__bottom__wrap__left__time__arrived").each(function (i, e) {

        var start_time = new Date($(e).data('start')),
            finish_time = new Date($(e).data('finish'))


        $(e).find(".timer").countdown(finish_time, function (event) {

            var current_time = new Date(),
                per_time = 100 / (Math.abs(finish_time - start_time) / 1000),
                pass_time = (Math.abs(current_time - start_time) / 1000) * per_time;


            if (finish_time > current_time && current_time > start_time) {
                var format = '%M : %S';

                if (event.offset.hours > 0) {
                    format = '%H : ' + format;
                }
                if (event.offset.days > 0) {
                    format = '%D : ' + format;
                }

                $(e).find(".single-product__wrapper__content__bottom__wrap__left__time__arrived__title span").html(event.strftime(format));
                $(e).find(".single-product__wrapper__content__bottom__wrap__left__time__arrived__progressbar__development").css("width", pass_time + '%');

            }
            $(e).find(".single-product__wrapper__content__bottom__wrap__left__time__arrived__title span").html(
                event.strftime(`
                    <div class="span"><span>%S</span><span>ثانیه</span></div>
                    <div class="span"><span>%M</span><span>دقیقه</span></div>
                    <div class="span"><span>%H</span><span>ساعت</span></div>
                    <div class="span"><span>%D</span><span>روز</span></div>
                  
                   
                        `)
            );

        });

    });

    //========= end countdowun =========//


    //sidebar-archive-p category//
    $(".sidebar-archive-p__wrapper__cat__item__title").on("click", function () {
        let $this = $(this);
        $this.closest(".sidebar-archive-p__wrapper__cat__item").find(".sidebar-archive-p__wrapper__cat__item__content").toggleClass("active");
    })

    $(".sidebar-archive-p__wrapper__filter > ul > li > i").on("click", function () {
        $(this).closest('.sidebar-archive-p__wrapper__filter > ul > li').remove();
    })

    $(".sidebar-archive-p__wrapper__title__heading:not(.sidebar-archive-p__wrapper__title__heading--red)").on("click", function () {
        $(this).closest(".sidebar-archive-p__wrapper__title").toggleClass("active");
        if ($(this).closest("sidebar-archive-p__wrapper").has(".sidebar-archive-p__wrapper__cat")) {
            $(this).closest(".sidebar-archive-p__wrapper").find(".sidebar-archive-p__wrapper__cat").slideToggle(300);
        }
        if ($(this).closest("sidebar-archive-p__wrapper").has(".sidebar-archive-p__wrapper__price")) {
            $(this).closest(".sidebar-archive-p__wrapper").find(".sidebar-archive-p__wrapper__price").slideToggle(300);
        }
        if ($(this).closest("sidebar-archive-p__wrapper").has(".sidebar-archive-p__wrapper__berand")) {
            $(this).closest(".sidebar-archive-p__wrapper").find(".sidebar-archive-p__wrapper__berand").slideToggle(300);
        }
    })
    // end sidebar-archive-p category//


    //reng price//
    if ($(".sidebar-archive-p__wrapper__price").length) {
        var price = document.getElementById('price');
        noUiSlider.create(price, {
            start: [150000, 5050000],
            connect: true,
            behaviour: 'tap',
            direction: 'rtl',
            range: {
                'min': [100000],
                '10%': [200000],
                '50%': [400000],
                'max': [6000000]
            },
            format: wNumb({
                decimals: 0,
                thousand: ','
            })
        });
        var nodes = [
            document.getElementById('lower-value'),
            document.getElementById('upper-value')
        ];
        price.noUiSlider.on('update', function (values, handle, unencoded, isTap, positions) {
            nodes[handle].innerHTML = values[handle];
        });
    }
    //end reng price//

    //=====menu mobile=========//
    $('[data-toggle]').on('click', function () {
        let toggle_name = $(this).data('toggle');
        let target_name = $(this).data('target');
        let target_element = $(
            '[data-toggle="showbox"][data-target="' + target_name + '"]'
        );
        if (toggle_name == 'openbox') {
            let target_status = target_element.data('status');
            $(
                '[data-toggle="showbox"]:not([data-target="' + target_name + '"])'
            ).attr('data-status', false);
            if (target_status == false) {
                target_element.attr('data-status', true);
            } else {
                target_element.attr('data-status', false);
            }
        } else if (toggle_name == 'closebox') {
            target_element.attr('data-status', false);
        }
    });
    $(document).on('click', function () {
        $('[data-toggle="showbox"]').attr('data-status', false);
    });
    $(document).on('keyup', function (e) {
        if (e.key === 'Escape') {
            $('[data-toggle="showbox"]').attr('data-status', false);
        }
    });
    $('[data-toggle="showbox"],[data-toggle="openbox"]').click(function (
        event
    ) {
        event.stopPropagation();
    });
    //=====end menu mobile======//


    //===========/map-contact-us==========//
    if ($('#mapid').length > 0) {
        var mymap = L.map('mapid').setView([32.6538472, 51.6724925], 18);
        L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw', {
            attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
            maxZoom: 18,
            id: 'mapbox/streets-v11',
            tileSize: 512,
            zoomOffset: -1,
            accessToken: 'your.mapbox.access.token'
        }).addTo(mymap);

        var map_icon = L.icon({
            iconUrl: './assets/img/location.png',
            iconSize: [30, 42],
            iconAnchor: [30, 42],
            popupAnchor: [0, -40]
        });
        var marker = L.marker([32.6538472, 51.6724925], { icon: map_icon, }).addTo(mymap);
    }
    //===========end map-contact-us==========//



    //===========timer==========//
    function countDownTimer(delay) {
        var d = new Date();
        var n = d.getSeconds();
        d.setSeconds(n + parseInt(delay));
        $('#clock').countdown(d)
            .on('update.countdown', (e) => {
                $(e.currentTarget).html(e.strftime('دریافت مجدد کد تا %-S ثانیه دیگر'));
            })
            .on('finish.countdown', (e) => {
                $(e.currentTarget).html('<a class="resend_token" href="#">ارسال مجدد کد</a>')
            });

    }

    countDownTimer(10);
    $(document).on('click', '.resend_token', function () {
        countDownTimer(10);
    });
    //===========end timer==========//


    //===========tab-content==========//

    $(document).on('click', '[data-tab]', function () {
        let $this = $(this),
            tab = $this.data('tab'),
            target = $this.data('tab-target');

        $('[data-tab][data-tab-target="' + target + '"]').removeClass('active');
        $this.addClass('active');


        $('[data-tab-content][data-tab-target="' + target + '"]').removeClass(
            'active'
        );
        $(
            '[data-tab-content="' + tab + '"][data-tab-target="' + target + '"]'
        ).addClass('active');
    });
    //=========== end tab =========//


    //==================== plus or minus product ====================//
    $(document).on("click", ".single-product__wrapper__content__bottom__wrap__left__btn__buy__button__count i", function () {
        var $this = $(this),
            type = $this.attr("data-type"),
            input = $this.closest(".single-product__wrapper__content__bottom__wrap__left__btn__buy__button__count").find("input"),
            value = parseInt(input.val()),
            min = input.attr('min'),
            max = input.attr('max'),
            number = $this.closest(".single-product__wrapper__content__bottom__wrap__left__btn__buy__button__count").find("span");
        if (type == "minus") {
            if (value > min) {
                value--;
            }
        }
        else if (type == "plus") {
            if (value < max) {
                value++;
            }
        }
        number.html(value);
        input.val(value);
    })
    // end plus or minus product//




    //   $('.content-error__total__content-login__tab-content__menu ul li ').on('click', function () {
    //     $('.content-error__total__content-login__tab-content__menu ul li ').removeClass('active');
    //     $(this).addClass('active');

    //   });
    //   //



    $('.content-error__total__content-login__tab-content__menu ul li ').on('click', function () {
        $('.content-error__total__content-login__tab-content__menu ul li ').removeClass('active');
        $(this).addClass('active');

    });

    $('.content-error__total__content-login__tab-content__menu ul li ').on('click', function () {
        $(this).siblings().removeClass('active');
        $(this).addClass('active');

    });


    function countDownTimer(delay) {
        var d = new Date();
        var n = d.getSeconds();
        d.setSeconds(n + parseInt(delay));
        $('#clock').countdown(d)
            .on('update.countdown', (e) => {
                $(e.currentTarget).html(e.strftime('ارسال مجدد کد تا %-S ثانیه دیگر'));
            })
            .on('finish.countdown', (e) => {
                $(e.currentTarget).html('<a class="resend_token" href="#">ارسال مجدد کد</a>')
            });

    }

    countDownTimer(10);
    $(document).on('click', '.resend_token', function () {
        countDownTimer(10);
    });
    //===========end tab-content==========//

    $('.content-cart__wraper__num__footerline__add').each(function () {
        var qty = $(this),
            input = qty.find('input'),
            plus = qty.find('i[data-type="plus"]'),
            minus = qty.find('i[data-type="minus"]'),
            min = input.attr('min'),
            max = input.attr('max'),
            number = qty.find('span');

        plus.click(function () {
            var oldValue = parseFloat(input.val());
            if (oldValue >= max) {
                var newVal = oldValue;
            } else {
                var newVal = oldValue + 1;
            }
            input.val(newVal);
            input.trigger('change');
            number.html(newVal);
        });

        minus.click(function () {
            var oldValue = parseFloat(input.val());
            if (oldValue <= min) {
                var newVal = oldValue;
            } else {
                var newVal = oldValue - 1;
            }
            input.val(newVal);
            input.trigger('change');
            number.html(newVal);
        });
    });

    $('.content-cart__wraper__num__footerline__delete').on('click', function () {
        $(this).closest('.content-cart__wraper ul li').remove();
    })


    $(document).ready(function () {
        $(".mobile-menu nav > ul > li >a").click(function () {
            var target = $(this).parent().children(".mobile-menu nav > ul > li >ul");
            $(target).slideToggle();
        });
    });

    const lightbox = GLightbox()
    $('.grid').isotope({
        // options
        itemSelector: '.grid-item',
        layoutMode: 'masonry', 
        columnWidth: 200
    });


    $('.sidebar-archive-p__wrapper__cat li').each((i,e)=>{
        let $this = $(e);
        if($this.find('>ul').length){
            const toggle = $('<i class="dn-arrow-bottom"></i>')
            $this.append(toggle)
            toggle.on('click',()=>{
                $this.find('>ul').slideToggle()
                $this.toggleClass('active')
            })
        }
    })

});